var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 6.08813C12.8804 6.31581 13.497 7.10983 13.5 8.02054C13.497 8.93125 12.8804 9.72527 11.9994 9.95295V10.5237C11.9943 12.5766 10.4389 14.2933 8.39782 14.4986C8.15419 15.1882 7.44958 15.6019 6.72924 15.4782C6.00889 15.3545 5.48236 14.7295 5.48236 13.998C5.48236 13.2665 6.00889 12.6414 6.72924 12.5177C7.44958 12.3941 8.15419 12.8077 8.39782 13.4974C9.88609 13.297 10.9973 12.0266 10.9989 10.5237V5.51742C11.0014 4.40762 10.5436 3.34656 9.73473 2.58737C8.9259 1.82817 7.83856 1.4389 6.7321 1.51243C4.58681 1.69907 2.95319 3.51788 2.9955 5.67261V10.023H2.49529C1.48994 10.0202 0.642832 9.27112 0.516106 8.27296C0.38938 7.27481 1.02239 6.33754 1.99508 6.08313V5.67261C1.95172 2.98941 3.99483 0.732264 6.66708 0.511182C8.05127 0.418205 9.41132 0.908227 10.4187 1.86287C11.4249 2.81198 11.9965 4.13363 11.9994 5.51742V6.08813ZM1.49663 8.02054C1.49663 8.37752 1.68654 8.7075 1.99508 8.88662V7.15446C1.68654 7.33358 1.49663 7.66356 1.49663 8.02054ZM6.99722 14.5286C6.72096 14.5286 6.497 14.3045 6.497 14.028C6.497 13.7515 6.72096 13.5274 6.99722 13.5274C7.27348 13.5274 7.49743 13.7515 7.49743 14.028C7.49743 14.3045 7.27348 14.5286 6.99722 14.5286ZM12.4893 8.02054C12.4893 7.66709 12.3031 7.33983 11.9994 7.15947V8.88161C12.3031 8.70125 12.4893 8.37399 12.4893 8.02054Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.b257efd017e5a85ae5f0286209be44c1.svg";
export { ForwardRef as ReactComponent };